import React from 'react';
import Layout from '../../components/Layout';
import Help from './Help';

const title = 'Help Center — BestHand Support';
const description =
  'Get help with BestHand bookings, payments, cancellations, refunds, your account and safety. Find answers fast or contact our support team.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <Help />
      </Layout>
    ),
  };
}

export default action;
